import { useQuery } from '@tanstack/react-query';
import { UserSettingsResponse } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchCurrentUserSettings = async () => {
  const response = await CustomAxios.get<UserSettingsResponse>(`user-settings`);
  const { data } = response;
  return data;
};

export function useGetCurrentUserSettings() {
  const query = useQuery({
    queryKey: [queryKeys.currentUserSettings],
    staleTime: 1000 * 60 * 60,
    queryFn: fetchCurrentUserSettings,
  });

  return query;
}
